// Decorative overlays for equipped avatar frames.
// Illustrated PNG assets with transparent centers.

import React from "react";
import { COSMETIC_TYPES, COSMETICS_CATALOG } from "../../utils/cosmetics";

const PUBLIC = process.env.PUBLIC_URL || "";

const FRAME_ASSETS = COSMETICS_CATALOG.filter(
    (item) =>
        item.type === COSMETIC_TYPES.AVATAR_FRAME &&
        item.visualKey &&
        item.assetSrc
).reduce((map, item) => {
    map[item.visualKey] = `${PUBLIC}${item.assetSrc}`;
    return map;
}, {});

export function FrameAssetDecor({ visualKey }) {
    const src = FRAME_ASSETS[visualKey];
    if (!src) {
        return null;
    }

    return (
        <img
            className="profileImageFrame__assetDecor"
            src={src}
            alt=""
            aria-hidden="true"
            draggable={false}
        />
    );
}

export default function AvatarFrameDecor({ visualKey }) {
    return <FrameAssetDecor visualKey={visualKey} />;
}
